export const PLUGINS = [
    {
        id: 'adobe-commerce',
        name: 'Adobe commerce',
        logoImageName: 'adobe.svg',
        docUrl: 'https://docs.klarna.com/platform-solutions/adobe-commerce/adobe-commerce-244-and-above/kp-overview/?utm_source=merchant%20portal'
    },
    {
        id: 'woo-commerce',
        name: 'WooCommerce',
        logoImageName: 'woo.svg',
        docUrl: 'https://docs.klarna.com/platform-solutions/woocommerce/how-to-install-klarna-payments-on-woocommerce/?utm_source=merchant%20portal'
    },
    {
        id: 'prestashop',
        name: 'PrestaShop',
        logoImageName: 'prestashop.svg',
        docUrl: 'https://docs.klarna.com/platform-solutions/prestashop/?utm_source=merchant%20portal'
    },
    {
        id: 'salesforce-commerce',
        name: 'Salesforce Commerce',
        logoImageName: 'salesforce.svg',
        docUrl: 'https://github.com/klarna/sfcc-klarna-payments/tree/master/documentation'
    },
    {
        id: 'sap-commerce',
        name: 'SAP Commerce',
        logoImageName: 'sap.png',
        docUrl: 'https://github.com/klarna/SAP-Commerce-klarna-payments/tree/master/docs'
    }
];
